import { makeRequest } from '../../../../lib/api';
import {
  UpdateTireBrandRequestInterface,
  UpdateTireModelRequestInterface,
  // AddNewTireBrandRequestInterface,
  // AddNewTireModelRequestInterface,
} from '../api/tireStorageApi'; 

const CATALOG_TIRE_PATH = '/v1/catalog/vehicle';

const tireStorageV2Controller = {
  getTireBrands: (showDeleted = false): Promise<any> => {
    return makeRequest('get', `${ CATALOG_TIRE_PATH }/tire_brands?showDeleted=${ showDeleted }`);
  },

  updateTireBrand: (request:UpdateTireBrandRequestInterface): Promise<any> => {
    return makeRequest('put', `${ CATALOG_TIRE_PATH }/tire_brands`, request);
  },

  getTireModels: (showDeleted = false, brandId:number): Promise<any> => {
    return makeRequest('get', `${ CATALOG_TIRE_PATH }/tire_models?showDeleted=${ showDeleted }&brandId=${ brandId }`);
  },

  updateTireModel: (request:UpdateTireModelRequestInterface): Promise<any> => {
    return makeRequest('put', `${ CATALOG_TIRE_PATH }/tire_models`, request);
  },

  /* addNewTireModel: (request:AddNewTireModelRequestInterface): Promise<any> => {
    return makeRequest('post', `${ CATALOG_TIRE_PATH }/models`, request);
  }, */
  getTireBrandCategories: (brandId: number): Promise<any> => {
    return makeRequest('get', `${ CATALOG_TIRE_PATH }/1c/tires/brands/categories?tireBrandId=${ brandId }`);
  },

};

export { tireStorageV2Controller };
